import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { PullupFooterComponent } from './pullup-footer.component';

@NgModule({
    imports: [
        IonicModule,
        FormsModule,
        CommonModule,
        TranslateModule
    ],
    exports: [PullupFooterComponent],
    declarations: [PullupFooterComponent],
    providers: [],
})
export class PullupFooterModule { }
